import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { Button } from './ui/Button';
export const HeroSection = () => {
  const bullets = ['Sin meditación', 'Sin pastillas', 'Sin fuerza de voluntad', 'Sin técnicas complicadas'];
  return <section className="relative min-h-screen md:min-h-[90vh] flex items-center pt-8 pb-6 md:pt-20 md:pb-16 overflow-hidden bg-night-900" data-id="element-256">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-accent-blue/10 rounded-full blur-[120px] pointer-events-none" data-id="element-257" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full" data-id="element-258">
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-259">
          <span className="hidden md:inline-block py-1 px-3 rounded-full bg-night-800 border border-night-700 text-accent-light font-medium tracking-wide mb-6 text-[24px]" data-id="element-260">
            Para vos que no podes dormir.
          </span>

          <h1 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4 md:mb-10 text-white" data-id="element-261">
            Si estás leyendo esto a la noche con la{' '}
            <span className="text-gradient" data-id="element-262">cabeza a mil...</span>
            <br data-id="element-263" />
            esto es exactamente para vos.
          </h1>
        </motion.div>

        {/* Product mockup between headline and subtitle */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="w-full max-w-[140px] sm:max-w-[180px] md:max-w-xs mx-auto mb-4 md:mb-10" data-id="element-264">
          <a href="#compra" className="block relative group" data-id="element-265">
            <div className="absolute inset-0 bg-accent-blue/20 rounded-2xl blur-2xl transition-all duration-500 group-hover:bg-accent-blue/30 group-hover:blur-3xl" data-id="element-266" />
            <img src="https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=400&q=80" alt="Libro Apagá la Cabeza y Dormite" className="relative z-10 w-full h-auto rounded-xl md:rounded-2xl shadow-2xl border border-night-700 transition-transform duration-500 group-hover:-translate-y-2" data-id="element-267" />
          </a>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="text-center" data-id="element-268">
          <p className="text-sm sm:text-base md:text-xl text-gray-300 mb-3 md:mb-8 leading-relaxed max-w-2xl mx-auto" data-id="element-269">
            El sistema paso a paso para apagar pensamientos, bajar el cuerpo y
            dormirte.
            <span className="hidden md:inline" data-id="element-270">
              <br data-id="element-271" />
              <br data-id="element-272" />
              Aunque lleves semanas sin dormir bien. Aunque ya probaste de todo.
              Aunque tu cabeza no pare ni un segundo.
            </span>
          </p>

          <div className="grid grid-cols-2 gap-x-2 gap-y-1.5 mb-4 md:mb-10 md:inline-flex md:flex-col md:items-start md:space-y-3 md:gap-0 max-w-sm mx-auto md:max-w-none" data-id="element-273">
            {bullets.map((bullet, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.5 + idx * 0.1
          }} className="flex items-center gap-1.5 md:gap-3 text-gray-200" data-id="element-274">
                <CheckCircle2 className="w-4 h-4 md:w-6 md:h-6 text-accent-blue shrink-0" data-id="element-275" />
                <span className="text-xs md:text-lg" data-id="element-276">{bullet}</span>
              </motion.div>)}
          </div>

          <div className="space-y-2 md:space-y-4 max-w-xl mx-auto" data-id="element-277">
            <Button href="#compra" fullWidth className="text-center !py-3 !text-base md:!py-4 md:!text-xl" data-id="element-278">
              QUIERO APAGAR LA CABEZA Y DORMIRME ESTA NOCHE
            </Button>
            <p className="text-center text-gray-400 text-xs md:text-sm" data-id="element-279">
              Acceso inmediato por $19.999
            </p>
            <div className="flex flex-wrap justify-center gap-1.5 md:gap-2 text-[10px] md:text-xs text-gray-500 font-medium" data-id="element-280">
              <span data-id="element-281">🔒 Pago seguro</span>
              <span data-id="element-282">·</span>
              <span data-id="element-283">Acceso instantáneo</span>
              <span data-id="element-284">·</span>
              <span data-id="element-285">PDF descargable</span>
              <span data-id="element-286">·</span>
              <span data-id="element-287">Funciona esta misma noche</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};